export const hrPolicyApi = {
    heading:[
        {
            head:"Policy Name"
        },
        {
            head:"Department"
        },
        {
            head:"Description"
        },
        {
            head:"Created"
        },
        {
            head:"Expire"
        },
        {
            head:"Action"
        },
    ],
    data:[
        {
            policyname:"Academic policy",
            department:"Academic",
            description:"this is a policy description and it is great policy from the companies end",
            created:"9 september",
            expire:"10 september",
            action:"./assets/images/dashboards/adminDashboard/HR/icons/threedotsicon.png"
        },

    ]
}